import script from "./AppNavigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppNavigation.vue?vue&type=script&lang=ts&setup=true"

import "./AppNavigation.vue?vue&type=style&index=0&id=65144728&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65144728"]])

export default __exports__